import { VitalSignsStatus } from '@redux/person/personTypes';

export const getVitalStatusOutOfRangeText = (status?: VitalSignsStatus) => {
  switch (status) {
    case VitalSignsStatus.ABNORMAL:
      return 'Abnormal';
    case VitalSignsStatus.SUBOPTIMAL:
      return 'Suboptimal';
    default:
      return '';
  }
};

export const getSleepStatusOutOfRangeText = (status?: VitalSignsStatus) => {
  switch (status) {
    case VitalSignsStatus.ABNORMAL:
      return 'Pay Attention';
    case VitalSignsStatus.SUBOPTIMAL:
      return 'Pay Attention';
    default:
      return '';
  }
};
